
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mail-vendor-general-terms",
      function () {
        return require("private-next-pages/mail-vendor-general-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mail-vendor-general-terms"])
      });
    }
  